import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import TickIcon from "../../assets/check.png";
// import "./rx.scss";

const ShareReceiptModal = (props) => {
  const { show, handleClose } = props;

  return (
    <div>
      {show && (
        <Modal show={show} centered>
          <Modal.Body>
            <div className="p-lg-5 p-2 text-center">
              <img src={TickIcon} alt="" />
              <h3 className="mt-4">Receipt Shared Successfully!</h3>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
};

export default ShareReceiptModal;
